import { BiSolidMedal } from "react-icons/bi";

interface Interface {
  title: string;
  institution: string;
  startYear: number;
  endYear?: number;
}

export default function Certification(attributes: Interface) {
  const yearLabel =
    attributes.endYear == null
      ? `${attributes.startYear} – Presente`
      : attributes.endYear === 0
        ? `${attributes.startYear}`
        : `${attributes.startYear} – ${attributes.endYear}`;

  return (
    <div className="flex items-start gap-4 p-4 rounded-xl bg-gray-800/60 border border-gray-700/40 hover:border-gray-600/60 transition-colors duration-200">
      <div className="flex flex-col gap-0.5 min-w-0">
        <span className="text-sm font-semibold text-white leading-snug">
          {attributes.title}
        </span>
        <span className="text-xs text-gray-500 flex flex-wrap gap-1 items-center">
          <span className="text-gray-400">{attributes.institution}</span>
          <span className="text-gray-700">·</span>
          <span>{yearLabel}</span>
        </span>
      </div>
    </div>
  );
}
